import { render } from "./SinistroCobrancaDetalheView.vue?vue&type=template&id=7180ed8c&scoped=true"
import script from "./SinistroCobrancaDetalheView.vue?vue&type=script&lang=js"
export * from "./SinistroCobrancaDetalheView.vue?vue&type=script&lang=js"

import "./SinistroCobrancaDetalheView.vue?vue&type=style&index=0&id=7180ed8c&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7180ed8c"]])

export default __exports__